export const paymentDepositTieringConfig = {
    paymentDepositTieringConfig: "Payment Deposit Tiering Config",
    depositTieringName: "Name",
    depositTieringAccumulatedAmount: "Accumulated Amount",
    depositTieringAccumulatedDepositTransaction: "Accumulated Deposit Transaction",
    depositTieringMinimumAmount: "Minimum Amount",
    depositTieringAccountName: "Account Name",
    depositTieringPaymentName: "Payment Name",
    depositTieringEdit: "Edit",
    depositBankName: "Name",
    depositBankBankAccountNameTh: "Account Name Th",
    depositBankBankAccountNameEn: "Account Name En",
    depositBankBankAccountNumber: "Account Number",
    paymentDepositBankAdd: "Add",
    paymentDepositBankConfig: "Payment Deposit Bank Config",
    paymentDepositBankSearchName: "Search By Name",
    PaymentConfigEditDepositTieringConfig: "Edit Deposit Tiering Config",
    PaymentConfigCreateDepositTieringConfig: "Create Deposit Tiering Config",
    depositTieringBank: "Account",
    PaymentDepositBankCreateDepositBank: "Create Deposit Bank",
    PaymentDepositBankEditDepositBank: "Edit Deposit Bank",
    depositBankBankProvider: "Bank Provider",
    paymentDepositTieringAdd: "Add",
    depositTieringEditPriorityDown: "⬇",
    depositTieringEditPriorityUp: "⬆",
    depositTieringPriority: "priority",
    depositTieringDelete: "Delete",
    depositType: "Deposit Type",
    depositTypeBankAccount: "Bank Account",
    depositTypePaymentGateway: "Payment Gateway",
    selectedPaymentDepositBank: "Selected Deposit Bank",
    selectedPaymentDepositPaymentGateway: "Selected Payment Gateway",
    deleteSelected:"Delete",
    depositBankProvider: "Bank Provider",
};
